module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Foreword#FORE"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(", by John Witte, Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface01#PRE1"
    }
  }, [_c('em', [_vm._v("Preface to the Collected Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface02#PRE2"
    }
  }, [_c('em', [_vm._v("Preface to Volume 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONE")]), _vm._v(": O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERVIEWS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1.1"
    }
  }, [_c('strong', [_vm._v("A. Normative Overviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_c('em', [_vm._v("39 DePaul Law Review 993 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_vm._v("The Benefits of the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_c('em', [_vm._v("42 DePaul Law Review 373 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_vm._v("Religious Liberty as Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("7 Journal of Contemporary Legal Issues 313 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Exercise Clause and Establishment Clause: General Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Religion and American Law: An Encyclopedia 516 (Paul Finkelman, ed., 2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty: Not for Religion or against Religion, but for Individual Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3 UT Law 42 (No. 1, Spring 2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty: Avoiding the Extremes but Missing the Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("118 Harvard Law Review 156 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Substantive Neutrality Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("110 West Virginia Law Review 51 (2007)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remarks on Acceptance of National First Freedom Award from the Council for America’s First Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("January 15, 2009")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#PT1.2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Analytic and Descriptive Overviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#PT1.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Survey of Religious Liberty in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#PT1.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("47 Ohio State Law Journal 409 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#PT1.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty: The Legal Rights of Religious Belief and Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#PT1.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("30 Concern No. 1, at 16 (Jan. 1988)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#PT1.2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Freedom and International Human Rights in the United States Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#PT1.2.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Emory International Law Review 951 (1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#PT1.2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Round Table Discussion on International Human Rights Standards in the United States: The Case of Religion or Belief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#PT1.2.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Emory International Law Review 973 (1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#PT1.2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Supreme Court and Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#PT1.2.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("40 Catholic Lawyer 25 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#PT1.2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vouching towards Bethlehem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#PT1.2.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religion in the News 2 (Summer 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter17#PT1.2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church and State in the United States: Competing Conceptions and Historic Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter17#PT1.2.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("13 Indiana Journal of Global Legal Studies 503 (2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/026_Chapter18#PT1.2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty in America: A Rapid Fire Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter18#PT1.2.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("33 Human Rights No. 3, at 3 (Summer 2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter19#PT1.2.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Conscripted Prophet’s Guesses about the Future of Religious Liberty in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter19#PT1.2.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("October 25, 2007")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter20#PT1.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. Book Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter21#PT1.3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections on Two Themes: Teaching Religious Liberty and Evolutionary Changes in Casebooks: Reviewing John T. Noon, Jr., "), _c('em', [_vm._v("Believers and the Powers That Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter21#PT1.3.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("101 Harvard Law Review 1642 (1988)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter22#PT1.3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Note: Reviewing Mark V. Tushnet’s "), _c('em', [_vm._v("Red, White, and Blue:")]), _vm._v(" "), _c('em', [_vm._v("A Critical Analysis of Constitutional Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter22#PT1.3.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("31 Journal of Church and State 303 (1989)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter23#PT1.3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Note: Reviewing Jesse H. Choper’s "), _c('em', [_vm._v("Securing Religious Liberty: Principles for Judicial Interpretation of the Religion Clauses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter23#PT1.3.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("44 Political Studies 1015 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter24#PT1.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("D. Judicial Nominations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter25#PT1.4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy Is Enough to Deny Senate Consent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter25#PT1.4.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("USA Today 10A (Sept. 15, 1987)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter26#PT1.4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senators Joseph R. Biden and Strom Thurmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter26#PT1.4.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Nomination of Robert H. Bork to Be Associate Justice of the Supreme Court of the United States 6099 (1987)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter27#PT1.4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Review: Reviewing Robert H. Bork’s "), _c('em', [_vm._v("The Tempting of America: The Political Seduction of the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter27#PT1.4.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("101 Ethics 661 (1991)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter28#PT1.4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Patrick Leahy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter28#PT1.4.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("(July 2, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter29#PT1.4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Orrin G. Hatch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter29#PT1.4.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Confirmation Hearings on Federal Appointments 737 (Senate Committee on the Judiciary 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/038_Chapter30#PT1.4.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forging Ideological Compromise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter30#PT1.4.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("New York Times A31 (Sept. 18, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter31#PT1.4.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some of the False Attacks on Michael McConnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter31#PT1.4.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Confirmation Hearings on Federal Appointments 737 (Senate Committee on the Judiciary 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter32#PT1.4.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judicial Nominations in a Divided Government")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter32#PT1.4.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Austin American-Statesman A15 (Oct. 9, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter33#PT1.4.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Injudicious: Liberals Should Get Tough on Bush’s Conservative Judicial Nominees—and Stop Opposing Michael McConnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter33#PT1.4.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The American Prospect Online (Oct. 30, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter34#PT2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TWO")]), _vm._v(": H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter35#PT2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Founders Wanted Total Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter35#PT2.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("USA Today 8A (Aug. 12, 1985)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter36#PT2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Nonpreferential” Aid to Religion: A False Claim about Original Intent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter36#PT2.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("27 William & Mary Law Review 875 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter37#PT2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responding to the Nonpreferentialists: A Review of Thomas J. Curry’s "), _c('em', [_vm._v("The First Freedoms: Church and State in America to the Passage of the First Amendment")]), _vm._v(" (1986), and Leonard W. Levy’s "), _c('em', [_vm._v("The Establishment Clause: Religion and the First Amendment")]), _vm._v(" (1986)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter37#PT2.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Journal of Law and Religion 241 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter38#PT2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text, Intent, and the Religion Clauses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter38#PT2.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Notre Dame Journal of Law, Ethics, and Public Policy 683 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter39#PT2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Original Intent and the Constitution Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter39#PT2.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The First Freedom: Religion and the Bill of Rights 87 (James E. Wood, ed., 1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter40#PT2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Declaration Is Not Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter40#PT2.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Quarterly, A Publication of the Christian Legal Society 8 (Fall 1991)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/049_Chapter41#PT2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Noncoercive” Support for Religion: Another False Claim about the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter41#PT2.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("26 Valparaiso University Law Review 37 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter42#PT2.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuity and Change in the Threat to Religious Liberty: The Reformation Era and the Late Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter42#PT2.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("80 Minnesota Law Review 1047 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter43#PT2.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty and Free Exercise: Back to the Future—What 21st Century Legal Culture Can Learn from the 19th Century’s First Amendment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter43#PT2.12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1 Engage 132 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter44#PT2.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regulatory Exemptions of Religious Behavior and the Original Understanding of the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter44#PT2.13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("81 Notre Dame Law Review 1793 (2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter45#PT3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THREE")]), _vm._v(": A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDICES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“God Alone Is Lord of the Conscience”: Policy Statement and Recommendations Regarding Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Committee on Religious Liberty and Church/State Relations, Presbyterian Church (U.S.A.) (1988) (reprinted in 8 Journal of Law & Religion 331 [1990])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Legal Citations for Nonlegal Readers")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfd2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0